import HpManager from "./HpManager";

export default HpManager;
export { HpManager };
